import { gql } from '@apollo/client';

export const ENGINE_SCORING_GRID_DELETED = gql`
  subscription engineScoringGridDeleted {
    engineScoringGridDeleted {
      engineScoringId
    }
  }
`;
